































































































import commerceType from '@/store/types/commerce';
import DatesFormat from '@/util/classes/datesFormat';
import image from '@/assets/images/no-image-available.png';
import { itemsRoute, navLink } from '@/ts/navegationLinks';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
declare type modelTypeArray = {
  id: string;
  value: string;
};

export default Vue.extend({
  name: 'CommercePartnersDetail',
  data: () => ({
    image,
    loading: true,
    items: [
      {
        id: 1,
        icon: 'ni ni-shop',
        title: 'Perfil',
        route: 'partners-profile',
        hash: 'profile',
      },
      {
        id: 2,
        icon: 'ni ni-briefcase-24',
        title: 'Sucursales',
        route: 'partners-branchs',
        hash: 'branchs',
      },
      {
        id: 3,
        icon: 'ni ni-building',
        title: '',
        route: 'partners-companies',
        hash: 'companies',
      },
      {
        id: 4,
        icon: 'ni ni-album-2',
        title: 'Imágenes',
        route: 'partners-banner-logo',
        hash: 'banner-logo-merchant',
      }
    ] as itemsRoute[],
    navlink: [
      {
        name: '', // Assigned in created
        active: false,
        to: '/commerce/partners',
      },
      {
        name: 'Información de comercio',
        active: true,
      }
    ] as navLink[],
    model_type_array: [
      {
        id: 'comida',
        value: 'Comida',
      },
      {
        id: 'bebida',
        value: 'Bebida',
      }
    ] as modelTypeArray[],
  }),
  created() {
    this.navlink[0].name = `${this.$t(
      'menu.commerce.plural.formal'
    )} afiliados`;
    this.items[2].title = this.$t(
      'company.commerce.profile.heading.company'
    ).toString();
    this.singleCommerce(this.$route.params.commerce_id);
    this.loading = false;
  },
  computed: {
    ...mapGetters({
      getSingleComerce: `commerceModule/${commerceType.getters.GET_SINGLE_COMMERCE}`,
    }),
  },
  methods: {
    ...mapActions({
      singleCommerce: `commerceModule/${commerceType.actions.SINGLE_COMMERCE}`,
    }),
    createdAt(date: string): string {
      const dateFormat = new DatesFormat();
      return dateFormat.formatDate(date);
    },
    logoImage(url: string): string {
      if (!url) {
        return this.image;
      }
      return url;
    },
  },
});
